import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid2,
  TextField,
  Typography,
} from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import NoteBackgroundImg from "../../../../assets/images/note-background.png";
import {
  StyledDialog,
  StyledFlexColumnView,
} from "../../../common-components/StyledComponents";
import CommonButton from "../../../../component/Button";

const ScheduleInterview = ({
  calendlyEvent,
  onClose,
  storageData,
  handleScheduleSubmit,
}) => {
  const validationSchema = Yup.object({
    event: Yup.object().nullable().required("Event is required"),
  });

  return (
    <StyledDialog
      fullWidth
      maxWidth="xs"
      open={calendlyEvent?.open}
      onClose={onClose}
    >
      <img
        src={NoteBackgroundImg}
        alt="background"
        style={{ position: "absolute", width: "max-content", opacity: "0.7" }}
      />

      {/* Close Button */}
      <DialogActions>
        <Button onClick={onClose}>
          <CloseIcon />
        </Button>
      </DialogActions>

      {/* Title */}
      <DialogTitle>
        <Typography variant="h5" mt={1}>
          Schedule Interview
        </Typography>
      </DialogTitle>

      {/* Content */}
      <DialogContent>
        <Formik
          initialValues={{ event: null }}
          validationSchema={validationSchema}
          onSubmit={handleScheduleSubmit}
        >
          {({ values, errors, touched, setFieldValue }) => (
            <Form
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault();
              }}
            >
              <Grid2 container direction="column" spacing={3}>
                {/* Interviewer */}
                <Grid2>
                  <StyledFlexColumnView>
                    <Typography variant="body1">Interviewer</Typography>

                    <Box
                      display="flex"
                      alignItems="center"
                      gap={1}
                      p={1.5}
                      borderRadius={2}
                      bgcolor="#FFFFFF"
                      border="1px solid #1018280D"
                      boxShadow="0px 1px 2px 0px #1018280D"
                    >
                      <Avatar
                        sx={{
                          width: 32,
                          height: 32,
                          fontWeight: 700,
                        }}
                      >
                        {storageData?.username?.charAt(0)?.toUpperCase()}
                      </Avatar>

                      <Typography variant="h6" textTransform="capitalize">
                        {storageData?.username}
                      </Typography>
                    </Box>
                  </StyledFlexColumnView>
                </Grid2>

                <Grid2>
                  <StyledFlexColumnView>
                    <Typography variant="body1">Event</Typography>

                    <Autocomplete
                      disablePortal
                      options={calendlyEvent?.data || []}
                      getOptionLabel={(option) => option?.name || ""}
                      value={values.event}
                      onChange={(_, value) => setFieldValue("event", value)}
                      isOptionEqualToValue={(option, value) =>
                        option?.id === value?.id
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Event"
                          error={touched.event && Boolean(errors.event)}
                          helperText={touched.event && errors.event}
                        />
                      )}
                      sx={{
                        "& .MuiAutocomplete-inputRoot": {
                          borderRadius: 2,
                          boxShadow: "0px 1px 2px 0px #10182840",
                        },
                        "& fieldset": {
                          border: "1px solid #10182840",
                        },
                        "& .MuiFormHelperText-root": {
                          fontWeight: 600,
                          margin: "3px 5px",
                        },
                      }}
                    />
                  </StyledFlexColumnView>
                </Grid2>

                <CommonButton
                  variant="contained"
                  value="Schedule"
                  type="submit"
                  padding="10px 0px"
                  fontWeight="600"
                  disabled={calendlyEvent.loading}
                  loading={calendlyEvent.loading}
                />
              </Grid2>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </StyledDialog>
  );
};

export default ScheduleInterview;
